<template>
  <v-text-field v-if="useVuetify" :style="{ width: '225px'}"  v-bind="$attrs" :model-value ="modelValue" @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)" :type="type">
    <slot></slot>
  </v-text-field>
  <input  v-else v-bind="$attrs" :type="type" :value ="modelValue" @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"/>
</template>

<script setup lang="ts">
import { inject } from 'vue';

defineOptions({
  inheritAttrs: false
})

const emit = defineEmits(['update:modelValue'])
defineProps({
  modelValue: String,
  type: {
    type: String,
    default: 'date'
  }
})
const useVuetify = inject("useVuetify",false);
</script>